import styled from "styled-components";
import ReCAPTCHA from "react-google-recaptcha";

import { content } from "../utils/helpers";
import RegisterForm from "../features/RegisterForm";
import { size } from "../utils/helpers";
import { useMemo, useState, useEffect, useRef } from "react";
import { getContent } from "../hooks/useGetContent";
import { Swiper, SwiperSlide } from 'swiper/react';
import { convertContentToArray } from "../utils/helpers";
import { Navigation, Pagination } from 'swiper';
import StarRating from "../components/StarRating";
import 'swiper/css';
import "swiper/css/navigation";
import 'swiper/css/pagination';
import Expressone from "../assets/imgg.png"


const FeedbackCard = ({
    image,
    title,
    subtitle,
    heading,
    rating,
    total,
    description,
}) => {
    return (
        <CardWrapper>
       
            <RatingHeader>
                <StarRating activeCount={rating} />
            </RatingHeader>
            {heading && (
                <CardHeading>{heading}</CardHeading>
            )}
            <CardDescription>{description}</CardDescription>
            <CardFooter>
                {image && (
                    <CardImage src={image} alt="" />
                )}
                <div>
                    <CardTitle>{title}</CardTitle>
                    <CardSubTitle>{subtitle}</CardSubTitle>
                </div>
            </CardFooter>
        </CardWrapper>
    );
}


const RegisterPage = ({ planData = { type: "starter" }, disabled }) => {
    const sitekey = "6Lf_8-wnAAAAAKg2EjPlV_lC4b4Vn6cJ6H0nXT8I";
    const recaptcha = useRef();
    const [links, setLinks] = useState([]);
    const [images, setImages] = useState([]);
    const [feedbacks, setFeedbacks] = useState([]);
    const [slidesPerView, setSlidePerView] = useState(1);
    const [planType, setPlanType] = useState(null);

    useEffect(() => {
        const handleResize = () => {
            setSlidePerView(1);
        }

        window.addEventListener('resize', handleResize);
        handleResize();

        const storedPlanData = localStorage.getItem('planData');
        if (storedPlanData) {
            setPlanType(JSON.parse(storedPlanData));
        }

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    useMemo(() => {
        getContent().then(response => {
            let feedbackData = response.homepage.fifthSectionContent?.content;
            if (feedbackData && feedbackData.length > 0) {
                const updatedContent = convertContentToArray(
                    ['embedded-asset-block', 'heading-1', 'heading-2', 'heading-3', 'heading-4', 'paragraph'],
                    ['image', 'title', 'subtitle', 'heading', 'rate', 'description'],
                    feedbackData);
                setFeedbacks(updatedContent.filter(item => item.title !== 'Jaxon Gill'));
            }
            const workingArray = response['pricing'].pricingPositives?.content;
            const lastImagesArray = workingArray.slice(-6);
            let theLinks = [];
            let theImages = [];
            workingArray.map((item) => {
                if (item.nodeType === "unordered-list") {
                    for (const list of item.content) {
                        theLinks.push(list.content?.[0]?.content?.[0]?.value);
                    }
                    setLinks(theLinks);
                }

            });
            lastImagesArray.map((item) => {
                if (item.nodeType === 'embedded-asset-block') {
                    theImages.push("https:" + item.data.target.fields.file.url);
                    setImages(theImages);
                }
            })
        })

    }, []);

    const checkMark = () => {
        return (
            <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="7" r="6.25" fill="#0050B2" stroke="white" strokeWidth="0.5" />
                <path d="M4 7.55L5.96512 9.5L10.5 5" stroke="white" strokeLinecap="round" />
            </svg>
        )
    }
    return (
        <>
            
      
        <RegisterContainer>
       
         <Title>{content.PublicPages.Register.Title1}</Title>
            <SubTitle2> Customize. Personalize. Win.</SubTitle2>
            {(planType?.type !== "free" || (planData && planData.type !== "free")) && (
                <>
                    {/* <Titleone>Create account: Step 1 of 2</Titleone> */}
                    {/* <LineWrap>
                        <Lineone>
                            <svg xmlns="http://www.w3.org/2000/svg" width="121" height="11" viewBox="0 0 121 11" fill="none">
                                <rect y="0.815918" width="120.317" height="10" rx="5" fill="#0A66C2" />
                            </svg>
                        </Lineone>
                        <Linetwo>
                            <svg xmlns="http://www.w3.org/2000/svg" width="121" height="11" viewBox="0 0 121 11" fill="none">
                                <g opacity="0.2">
                                    <rect y="0.815918" width="120.317" height="10" rx="5" fill="#0A66C2" />
                                </g>
                            </svg>
                        </Linetwo>
                    </LineWrap> */}
                </>
            )}
            <RegisterForm disabled={disabled} planData={planType || planData} id="register-step-one" captcha={recaptcha}
            >
                <Links>
                    {
                        (() => {
                            const list = [];
                            let i = 1;

                            for (const link of links) {
                                const updatedLink = link === 'No credit card required' ? 'Approved by top experts' : link;
                                list.push(<TheLink key={i}>{checkMark()} {updatedLink}</TheLink>);
                                i++;
                            }

                            return list;
                        })()
                    }
                </Links>
            </RegisterForm>
            {/* <CaptchaContainer>
                <ReCAPTCHA ref={recaptcha} sitekey={sitekey} />
            </CaptchaContainer> */}

            {/* <LineWrap>
                <Lineone><svg xmlns="http://www.w3.org/2000/svg" width="91" height="30" viewBox="0 0 91 30" fill="none">
                        <path d="M39.0294 28.6455H31.683L36.2744 0.963931H43.6215L39.0294 28.6455ZM25.5028 0.963931L18.4991 20.0036L17.6704 15.9036L17.6711 15.9051L15.1992 3.45634C15.1992 3.45634 14.9003 0.963931 11.7143 0.963931H0.135862L0 1.43265C0 1.43265 3.54072 2.15534 7.68451 4.59666L14.067 28.6463H21.7213L33.4092 0.963931H25.5028ZM83.2857 28.6455H90.0313L84.1499 0.963191H78.2445C75.5174 0.963191 74.8532 3.02613 74.8532 3.02613L63.8967 28.6455H71.5548L73.0863 24.5337H82.4253L83.2857 28.6455ZM75.2019 18.8536L79.0619 8.49448L81.2334 18.8536H75.2019ZM64.4711 7.62073L65.5195 1.67626C65.5195 1.67626 62.2845 0.469299 58.9121 0.469299C55.2664 0.469299 46.609 2.03242 46.609 9.63332C46.609 16.7847 56.77 16.8736 56.77 20.63C56.77 24.3864 47.6559 23.7133 44.6481 21.3445L43.5559 27.56C43.5559 27.56 46.8362 29.1231 51.848 29.1231C56.8613 29.1231 64.4243 26.5767 64.4243 19.6459C64.4243 12.4486 54.172 11.7785 54.172 8.64924C54.1727 5.51928 61.3274 5.92135 64.4711 7.62073Z" fill="#4B4B4B"/>
                        <path d="M17.6711 15.8926L15.1992 3.44389C15.1992 3.44389 14.9003 0.951477 11.7143 0.951477H0.135862L0 1.42019C0 1.42019 5.56506 2.55162 10.9029 6.7908C16.0068 10.8426 17.6711 15.8926 17.6711 15.8926Z" fill="#E6A540"/>
                </svg></Lineone>
                <Linetwo>
                <svg xmlns="http://www.w3.org/2000/svg" width="54" height="44" viewBox="0 0 54 44" fill="none">
                    <g clip-path="url(#clip0_714_1070)">
                        <path d="M53.4887 26.4817V25.9013H53.3221L53.1295 26.2996L52.9379 25.9013H52.7708V26.4817H52.8891V26.0445L53.0693 26.4218H53.1918L53.372 26.0435V26.4817H53.4892H53.4887ZM52.4321 26.4817V26.0007H52.6453V25.9028H52.1006V26.0007H52.3138V26.4817H52.431H52.4321Z" fill="#F79410"/>
                        <path d="M34.2177 28.458H19.8047V5.17105H34.218L34.2177 28.458Z" fill="#FF5F00"/>
                        <path d="M22.1519 16.8343C22.1519 12.0966 24.3798 7.8762 27.849 5.15639C25.223 3.0946 21.975 1.9756 18.6307 1.98052C10.3927 1.98052 3.71484 8.6307 3.71484 16.8343C3.71484 25.038 10.3927 31.6881 18.6307 31.6881C21.975 31.6931 25.2231 30.5741 27.8493 28.5123C24.3802 25.7929 22.1519 21.5723 22.1519 16.8343Z" fill="#EB001B"/>
                        <path d="M51.9843 16.8344C51.9843 25.038 45.3067 31.6882 37.0691 31.6882C33.7246 31.6931 30.4763 30.5741 27.8499 28.5123C31.3199 25.7925 33.5477 21.5723 33.5477 16.8344C33.5477 12.0964 31.3199 7.87623 27.8499 5.15642C30.4763 3.09469 33.7245 1.97571 37.0689 1.98055C45.3065 1.98055 51.9843 8.63073 51.9843 16.8344Z" fill="#F79E1B"/>
                        <path d="M52.942 39.9262V40.0229H53.0414C53.06 40.0232 53.0784 40.0189 53.0947 40.0106C53.1011 40.0064 53.1064 40.0008 53.1099 39.9944C53.1134 39.9879 53.115 39.9808 53.1147 39.9736C53.115 39.9665 53.1133 39.9595 53.1098 39.9532C53.1063 39.9469 53.1011 39.9415 53.0947 39.9375C53.0786 39.9288 53.0601 39.9245 53.0414 39.9252H52.942V39.9262ZM53.0424 39.8577C53.085 39.8553 53.1272 39.8665 53.1618 39.8892C53.1757 39.8995 53.1867 39.9126 53.194 39.9274C53.2012 39.9423 53.2046 39.9585 53.2037 39.9748C53.2043 39.9888 53.2016 40.0027 53.1958 40.0157C53.19 40.0286 53.1813 40.0403 53.1701 40.05C53.1434 40.071 53.1099 40.0837 53.0747 40.086L53.2079 40.2239H53.1053L52.9827 40.087H52.943V40.2239H52.8572V39.858H53.0438L53.0424 39.8577ZM53.0158 40.3501C53.0608 40.3505 53.1054 40.3422 53.1466 40.3259C53.1864 40.3104 53.2226 40.2881 53.2532 40.2604C53.2839 40.2326 53.3085 40.1998 53.3254 40.1636C53.3604 40.087 53.3604 40.0009 53.3254 39.9242C53.3082 39.8882 53.2837 39.8554 53.2532 39.8275C53.2226 39.7997 53.1864 39.7775 53.1466 39.762C53.1051 39.7465 53.0606 39.7388 53.0158 39.7392C52.9702 39.7388 52.9249 39.7466 52.8826 39.762C52.8419 39.7772 52.8049 39.7995 52.7736 39.8275C52.7264 39.8714 52.6945 39.9269 52.6819 39.9871C52.6692 40.0473 52.6764 40.1095 52.7024 40.1661C52.7186 40.2024 52.7428 40.2353 52.7736 40.2628C52.8049 40.2908 52.8419 40.3131 52.8826 40.3283C52.9247 40.3447 52.97 40.3529 53.0158 40.3525M53.0158 39.6512C53.1329 39.6511 53.2454 39.6928 53.3289 39.7673C53.3692 39.803 53.4013 39.8457 53.4232 39.8928C53.446 39.9411 53.4578 39.9932 53.4578 40.0457C53.4578 40.0983 53.446 40.1504 53.4232 40.1987C53.4007 40.2455 53.3687 40.2881 53.3289 40.3242C53.288 40.3598 53.2405 40.3885 53.1885 40.4089C53.1339 40.4299 53.0751 40.4406 53.0158 40.4403C52.9558 40.4407 52.8963 40.43 52.841 40.4089C52.7884 40.3889 52.7404 40.3602 52.6995 40.3242C52.6597 40.2868 52.6281 40.2428 52.6065 40.1946C52.5837 40.1463 52.572 40.0942 52.572 40.0416C52.572 39.9891 52.5837 39.937 52.6065 39.8887C52.6285 39.8416 52.6605 39.7989 52.7008 39.7632C52.7412 39.7265 52.7893 39.6977 52.8423 39.6785C52.8976 39.6574 52.9571 39.6467 53.0171 39.6471M12.2117 38.2381C12.2117 37.5404 12.7154 36.9673 13.5386 36.9673C14.3252 36.9673 14.8561 37.5158 14.8561 38.2381C14.8561 38.9605 14.3252 39.509 13.5386 39.509C12.7154 39.509 12.2117 38.9358 12.2117 38.2381ZM15.7528 38.2381V36.2527H14.8017V36.7363C14.5 36.3789 14.0425 36.1547 13.4203 36.1547C12.1944 36.1547 11.2324 37.0273 11.2324 38.2391C11.2324 39.451 12.1939 40.3235 13.4203 40.3235C14.0422 40.3235 14.5 40.0991 14.8017 39.7419V40.2239H15.7517V38.2381H15.7528ZM47.8886 38.2381C47.8886 37.5404 48.3923 36.9673 49.2157 36.9673C50.0032 36.9673 50.5332 37.5158 50.5332 38.2381C50.5332 38.9605 50.0032 39.509 49.2157 39.509C48.3926 39.509 47.8886 38.9358 47.8886 38.2381ZM51.4307 38.2381V34.659H50.4789V36.7363C50.1772 36.3789 49.7197 36.1547 49.0974 36.1547C47.8716 36.1547 46.9096 37.0273 46.9096 38.2391C46.9096 39.451 47.871 40.3235 49.0974 40.3235C49.7197 40.3235 50.1772 40.0991 50.4789 39.7419V40.2239H51.4307V38.2381ZM27.557 36.9264C28.1699 36.9264 28.5635 37.2752 28.6639 37.8892H26.3946C26.4961 37.316 26.8796 36.9264 27.5572 36.9264M27.5762 36.1525C26.2944 36.1525 25.3976 36.999 25.3976 38.2369C25.3976 39.4991 26.3303 40.3213 27.6398 40.3213C28.2986 40.3213 28.9019 40.1721 29.4327 39.7651L28.9667 39.1254C28.6 39.3915 28.1331 39.5407 27.6942 39.5407C27.0813 39.5407 26.5233 39.2831 26.386 38.5685H29.6337C29.643 38.4611 29.6526 38.3528 29.6526 38.2367C29.643 36.9992 28.7998 36.1523 27.5756 36.1523M39.0584 38.2367C39.0584 37.539 39.5621 36.9658 40.3852 36.9658C41.1719 36.9658 41.7027 37.5143 41.7027 38.2367C41.7027 38.9591 41.1719 39.5075 40.3852 39.5075C39.5621 39.5075 39.0582 38.9344 39.0582 38.2367M42.5992 38.2367V36.2527H41.6486V36.7363C41.3459 36.3789 40.8894 36.1547 40.2672 36.1547C39.0414 36.1547 38.0794 37.0273 38.0794 38.2391C38.0794 39.451 39.0408 40.3235 40.2672 40.3235C40.8894 40.3235 41.3459 40.0991 41.6486 39.7419V40.2239H42.5995V38.2381L42.5992 38.2367ZM33.6874 38.2367C33.6874 39.4408 34.6111 40.3211 36.0208 40.3211C36.6795 40.3211 37.1184 40.1881 37.593 39.8478L37.1363 39.1501C36.7792 39.383 36.4042 39.5075 35.9904 39.5075C35.2312 39.4991 34.6729 39.0009 34.6729 38.2367C34.6729 37.4725 35.2312 36.9745 35.9904 36.9658C36.4032 36.9658 36.7781 37.0904 37.1363 37.3233L37.593 36.6256C37.1176 36.2853 36.6787 36.1523 36.0208 36.1523C34.6111 36.1523 33.6874 37.0323 33.6874 38.2367ZM45.9484 36.1523C45.3997 36.1523 45.0423 36.3852 44.7953 36.7339V36.2527H43.8527V40.2217H44.8049V37.9968C44.8049 37.34 45.1159 36.975 45.7376 36.975C45.9412 36.9724 46.1433 37.0063 46.3324 37.0749L46.6255 36.2614C46.415 36.1862 46.1405 36.153 45.9478 36.153M20.4549 36.5683C19.9973 36.2945 19.3668 36.153 18.6713 36.153C17.5633 36.153 16.8499 36.635 16.8499 37.4236C16.8499 38.0708 17.381 38.4701 18.359 38.5946L18.8083 38.6526C19.3298 38.7192 19.576 38.8437 19.576 39.0679C19.576 39.3748 19.2296 39.5499 18.5791 39.5499C17.9204 39.5499 17.445 39.3588 17.1244 39.1346L16.6775 39.8077C17.199 40.1564 17.8577 40.3228 18.5711 40.3228C19.8343 40.3228 20.5663 39.783 20.5663 39.0273C20.5663 38.3296 19.9902 37.9646 19.0383 37.8401L18.59 37.7811C18.1783 37.7327 17.8484 37.6575 17.8484 37.3915C17.8484 37.1013 18.1594 36.9267 18.6812 36.9267C19.2395 36.9267 19.7799 37.1177 20.0448 37.2669L20.4565 36.5692L20.4549 36.5683ZM32.7268 36.1538C32.1781 36.1538 31.8207 36.3866 31.5747 36.7354V36.2527H30.6322V40.2217H31.5833V37.9968C31.5833 37.34 31.8943 36.975 32.516 36.975C32.7196 36.9724 32.9217 37.0063 33.1108 37.0749L33.4039 36.2614C33.1934 36.1862 32.9189 36.153 32.7262 36.153M24.6107 36.2527H23.0555V35.0486H22.094V36.2527H21.2069V37.0415H22.094V38.8522C22.094 39.7731 22.4879 40.3216 23.613 40.3216C24.0258 40.3216 24.5012 40.2055 24.8029 40.0147L24.5281 39.2756C24.2443 39.4248 23.9333 39.5 23.686 39.5C23.2106 39.5 23.0555 39.234 23.0555 38.8357V37.0423H24.6107V36.2527ZM10.3914 40.2227V37.7317C10.3914 36.7937 9.73264 36.1625 8.67071 36.154C8.11242 36.1455 7.53655 36.3032 7.13336 36.8602C6.8317 36.42 6.35629 36.154 5.68795 36.154C5.2208 36.154 4.76431 36.2785 4.40696 36.7434V36.2527H3.45508V40.2217H4.41442V38.021C4.41442 37.332 4.83547 36.9658 5.48569 36.9658C6.11725 36.9658 6.43677 37.3395 6.43677 38.0123V40.2212H7.39824V38.0205C7.39824 37.3315 7.83714 36.9654 8.46844 36.9654C9.11787 36.9654 9.42779 37.339 9.42779 38.0118V40.2207L10.3914 40.2227Z" fill="#4B4B4B"/>
  </g>
  <defs>
    <clipPath id="clip0_714_1070">
      <rect width="53.2968" height="43.5712" fill="white" transform="translate(0.698242)"/>
    </clipPath>
  </defs>
</svg>
</Linetwo>
   <CheckIcon src={Expressone} />
<Linetwo>
</Linetwo>

            </LineWrap> */}
            {/* <Section>
                {feedbacks.length > 0 && (
                    <ContentWrapper>
                        <Swiper
                            navigation={true}
                            slidesPerView={slidesPerView}
                            spaceBetween={16}
                            pagination={{
                                dynamicBullets: true,
                            }}
                            modules={[Navigation, Pagination]}
                        >
                            {feedbacks.map((feedback, index) => (
                                <SwiperSlide key={`feedback-${index}`}>
                                    <FeedbackCard
                                        image={feedback.image}
                                        title={feedback.title}
                                        subtitle={feedback.subtitle}
                                        rating={+feedback.rate}
                                        heading={feedback.heading}
                                        total={feedbacks.length}
                                        description={feedback.description}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </ContentWrapper>
                )}
            </Section> */}
        </RegisterContainer>
        </>
    );
}

const LineWrap = styled.section`
 display:flex;
 gap:10px;
`;

const Lineone = styled.section`
 
`;
const Linetwo = styled.section`
 
`;

const Section = styled.section`
  position: relative;
  margin: 20px 1rem 0;
  text-align: center;
  width: 100%;
`;

const RegisterContainer = styled.div`
    display: flex;
    align-items: center;
    flex-flow: column;
    // animation: image-fade-up-main .75s;
    padding: 0 15px;
    width: 90%;
    @media only screen and (min-width:${size.minWidthTablet}) {
        width:100%;
    }
`;

const Title = styled.h1`
        text-align: center;
        font-family: 'Space Grotesk', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 33px;
        line-height: 155.52%;
        margin-bottom: 9.7px;
        text-transform: capitalize;
        margin-top: 30px;
    @media only screen and (min-width: ${size.minWidthTablet}) {
        font-size: 33px;
        margin-top: 30px;
        color: #000;
        font-family: Space Grotesk;
        font-style: normal;
        font-weight: 700;
        line-height: 155.523%;
        margin-bottom: 0px;
    }
`;

const Titleone = styled.h1`
    text-align: center;
    font-family: 'Space Grotesk', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 155.52%;
    margin-bottom: 5px;
    // text-transform: capitalize;
    // margin-top: 30px;
    @media only screen and (min-width: ${size.minWidthTablet}) {
        font-size: 30px;
        margin-top: 0px;
        color: #000;
        font-family: Space Grotesk;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 155.523%;
        margin-bottom: 5px;
    }
`;

const Content = styled.p`
    font-size: 15.2px;
    line-height: normal;
    font-weight: 700px;
    text-align: center;
    color: #585858;
    margin-bottom: 19.1px;
    margin-top: 0;
    @media only screen and (min-width: ${size.minWidthTablet}) {
        color: #000;
        font-family: Space Grotesk;
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 24px;
    }
`;

const SpanLeft = styled.span`
    margin-right: 5px;
`;

const SpanRight = styled.span`
    color: #000000;
`;

const Steps = styled.div`
    display: flex;
`;
const StepBlock = styled.div`
    display: block;
    border-radius: 12px;
    width: 90px;
    height: 8px;
    background-color: var(--main-bg);
    opacity: ${props => props.active ? "1" : "0.2"};
    margin-left: 5.8px;
    @media only screen and (min-width: ${size.minWidthTablet}) {
        width: 120.32px;
        height: 10px;
    }
`;

const Links = styled.div`
    display: flex;
    margin-top: 10px;
    margin-bottom: 8px;
    // animation: popUp 2s;
    width: 100%;
    justify-content: space-between;
    max-width: 350px;
    @media only screen and (min-width: ${size.minWidthTablet}) {
        margin-top: 8px;
        margin-bottom: 0;
        grid-gap: 48px;
        max-width: 500px;
    }
`;

const TheLink = styled.div`
    display: flex;
    font-size: 15px;
    color: #222;
    line-height: 150.1%;
    font-weight: 700;
    letter-spacing: -0.555px;
    font-family: Space Grotesk;
    @media only screen and (max-width:480px){
        font-size: 13px;
    }
    > svg {
        width: 17.6px;
        height: 17.6px;
        margin-right: 5px;
    }
    @media only screen and (min-width: ${size.maxWidthTablet}) {
        font-size: 16px;
        line-height: 134.1%;;
        font-weight: 100;
        > svg {
            width: 20px;
            height: 20px;
        }    
    }
`;

const Images = styled.div`
    display: flex;
    flex-wrap: wrap;
    grid-gap: 30px;
    align-items: center;
    @media only screen and (max-width: ${size.minWidthTablet}) {
        grid-gap: 20px;
    }
`;
const CheckIcon = styled.img`
    width: 99px;
    height: 32px;
`;

const Image = styled.img`
    width: auto;
    max-width: 65px;
    height: auto;
    @media only screen and (min-width: ${size.minWidthTablet}) {
        max-width: 100px;
    }

`;
const ContentWrapper = styled.div`
    max-width: 400px;
    ${'' /* padding-left: 20px;
    padding-right: 20px; */}
    margin: 0 auto 40px auto;
    @media only screen and (min-width: ${size.minWidthDesktop}) {
        max-width: 600px;
    }
    @media only screen and (min-width: ${size.minWidthTablet}) {
        max-width: 780px;
    }
`;

const CardWrapper = styled.div`
  
    height: 450px;
    display: flex;
    flex-flow: column;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.12);
    padding: 30px;
    margin: 10px auto;
    @media only screen and (min-width: ${size.minWidthTablet}) {
    width: 600px;
    height: 240px;

    }
`;

const CardFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 12px;
`;

const CardImage = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 100%;
  object-fit: cover;
`;

const CardTitle = styled.h3`
  font-size: 20px;
  text-align: start;
  margin: 0;
`;

const CardSubTitle = styled.h4`
  font-size: 18px;
  font-weight: 400;
  text-align: start;
  margin: 0;
  margin-top: 4px;
  margin-bottom: 4px;
`;

const CardHeading = styled.h5`
  font-size: 16px;
  font-weight: 700;
  text-align: start;
  margin: 0;
  margin-top: 11px;
`;

const CardDescription = styled.p`
  flex-grow: 1;
  font-size: 16px;
  text-align: start;
  margin: 0;
  margin-top: 13px;
`;

const RatingHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CaptchaContainer = styled.div`
  margin: 20px auto;
  text-align: center;
`;

const SubTitle2 = styled.div`
  margin-bottom: 10px;
  text-align: center;
  font-size: 25px;
  font-weight: 500;
`;





export default RegisterPage;